export default {
    loading: false,
    items: null,
}